import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { SEND_MESSAGE } from "src/api-setup/api-endpoints";

export const sendMessage = async (cookiesData, dispatch, conversationId, inputText) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: String(cookiesData?.out_user_id),
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_conversation_mstr_key: conversationId ?? 0,
      in_message_text: inputText.trim(),
    };

    const response = await POSTAPI(false, SEND_MESSAGE, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response?.data?.out_parameters) {
      return response?.data?.out_parameters;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
